export const MESSAGE_OF_THE_DAY_MLB_TITLE = 'messageOfTheDay.mlb.title';
export const MESSAGE_OF_THE_DAY_MLB_SUBTITLE = 'messageOfTheDay.mlb.subtitle';
export const MESSAGE_OF_THE_DAY_MLB_CTA = 'messageOfTheDay.mlb.cta';
export const MESSAGE_OF_THE_DAY_NFL_TITLE = 'messageOfTheDay.nfl.title.v2';
export const MESSAGE_OF_THE_DAY_NFL_SUBTITLE =
  'messageOfTheDay.nfl.subtitle.v2';
export const MESSAGE_OF_THE_DAY_NFL_CTA = 'messageOfTheDay.nfl.cta.v2';
